import React from 'react';
import logo from './logo.svg';
import './App.css';
import Player from './Player';
import { artefactDemos, instruments, vibratoDemos, midiFileNameToDisplayName, instrumentIdToDisplayName } from './data';
import Introduction from './Introduction';
import { line, intersectionSpace } from './layout';
const scrollToRef = (ref) => window.scrollTo({ left: 0, top: ref.current.offsetTop - 20, behavior: 'smooth' });

const Artefacts = (props) => {
	const topRef = React.useRef(null);
	const refDataRef = React.useRef(null);
	const artefactRef = React.useRef(null);
	const art1 = React.useRef(null);
	const art2 = React.useRef(null);
	const art3 = React.useRef(null);
	const art4 = React.useRef(null);

	const artRefs = [art1, art2, art3, art4];

	React.useEffect(() => {
		if (props.location.search.includes('=')) {
			scrollToRef(artRefs[Number(props.location.search.split('=')[1])]);
		}
	}, [window.location.href]);
	return (
		<>
			<div style={{ display: 'flex', flexDirection: 'column', padding: '24px' }}>
				<h1>
					The control-synthesis approach for making expressive and controllable neural music synthesizers -
					Artefacts
				</h1>

				{line}
			</div>
			<div
				style={{
					display: 'flex',
					flexDirection: 'column',
					padding: '16px',
					justifyContent: 'center',
					margin: 'auto',
				}}
			>
				<div>
					<h2 ref={topRef}>Page index</h2>

					<ul>
						{[
							{ ref: refDataRef, title: 'Excerpts from the target datasets' },
							{ ref: artefactRef, title: 'Artefacts' },
						].map((section) => (
							<h3 style={{ cursor: 'pointer' }} onClick={() => scrollToRef(section.ref)}>
								{'➤ ' + section.title}
							</h3>
						))}
					</ul>
				</div>
				{intersectionSpace}
				<h2 ref={refDataRef}>Excerpts from the target datasets</h2>
				{line}
				<p style={{ maxWidth: 600 }}>These excerpts come from the datsets with which the models were trained</p>
				<div style={{ margin: 'auto', marginTop: 10, marginBottom: 20 }}>
					<Player
						title={'Excerpt from the classical violin dataset'}
						midiFilePath={' '}
						audioFilePath={process.env.PUBLIC_URL + `/audio/violin2/` + 'target.wav'}
					></Player>
				</div>
				<div style={{ margin: 'auto', marginTop: 10, marginBottom: 20 }}>
					<Player
						title={'Excerpt from the flute dataset'}
						midiFilePath={' '}
						audioFilePath={process.env.PUBLIC_URL + `/audio/flute2/` + 'target.wav'}
					></Player>
				</div>
				{intersectionSpace}
				<h2 ref={artefactRef}>Artefacts</h2>
				{line}

				{artefactDemos.map((art, idx) => (
					<React.Fragment>
						<h3 ref={artRefs[idx]}>{`Artifact #${idx + 1} : ` + art.title}</h3>
						<p style={{ maxWidth: 600 }}>{art.description}</p>
						{art.demos.map((demo, index) => (
							<div style={{ margin: 'auto', marginTop: 10, marginBottom: 20 }} key={index}>
								<Player
									title={
										instrumentIdToDisplayName(demo.instrumentId) +
										' : ' +
										midiFileNameToDisplayName(demo.fileName)
									}
									midiFilePath={process.env.PUBLIC_URL + '/midi/' + demo.fileName}
									audioFilePath={
										process.env.PUBLIC_URL +
										`/audio/${demo.instrumentId}/` +
										demo.fileName +
										'_generated_performance.wav'
									}
								></Player>
							</div>
						))}
						<hr></hr>
						<hr></hr>
						<hr></hr>
					</React.Fragment>
				))}
			</div>
			{intersectionSpace}
			<h2 style={{ textAlign: 'center', cursor: 'pointer' }} onClick={() => scrollToRef(topRef)}>
				Back to index ☝
			</h2>
		</>
	);
};

export default Artefacts;
